import defaultLogo from '../DV Logo.jpg';

import { isDemoMode } from '../utils/runtimeMode';

const defaultBranding = {
  name: 'Clocktower',
  logo: defaultLogo,
  logoAlt: 'Town of Diamond Valley logo',
  showTextLogo: false
};

const demoBranding = {
  name: 'Clocktower Demo',
  logo: 'https://www.dropbox.com/scl/fi/xn6co3kkt6s8ppem290pv/ClockTower-Banner-1000x383-2026-08-10_20-43-41.jpg?rlkey=hxl8pq2n1ooouz2u0dmha4vew&st=1383iuiz&raw=1',
  logoAlt: 'Clocktower demo',
  showTextLogo: false
};

export const getAppBranding = () => (
  isDemoMode() ? demoBranding : defaultBranding
);
